// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__qQHK6","contact-data":"Contact_contact-data__dkzLu"};